export function buildValidateOrderSpreadsheetQuery({ contractId, productId, calculationType, discountType, file, }) {
    const body = new FormData();
    body.append('productId', productId);
    body.append('calculationType', calculationType);
    body.append('file', file);
    if (discountType) {
        body.append('discountType', discountType);
    }
    return {
        url: `/v1/benefits/contracts/${contractId}/orders/spreadsheet/validate`,
        method: 'POST',
        body,
    };
}
export function transformValidateOrderSpreadsheetResponse(response) {
    return response.result;
}
